module.exports = __webpack_public_path__ + "img/pcr2.3da89aa9.png";